import { zeroPad } from './pad'

export default function isoFormat(date) {
  const year = date.getFullYear()
  let month = date.getMonth() + 1 // Months are zero-indexed
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let msecond = date.getMilliseconds()

  month = zeroPad(month, 2)
  day = zeroPad(day, 2)
  hour = zeroPad(hour, 2)
  minute = zeroPad(minute, 2)
  second = zeroPad(second, 2)
  msecond = zeroPad(msecond, 3)

  return `${year}-${month}-${day} ${hour}:${minute}:${second}.${msecond}`
}
